import React, { Component } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import StarRatings from "react-star-ratings";
import { Row, Col } from "react-materialize";

import BuyCourseButton from "./BuyCourseButton";
import { FormatPrice } from "../../Util";

class FloatingCourseBar extends Component {
  render() {
    const { data, onEnroll, onRedeem, errorMessage } = this.props;
    return (
      <div>
        {(!data.enrolled || data.completed) && (
          <div
            id="floating-course-bar"
            className="bg-white pad-s row mb-0 border-bottom shadowed"
          >
            <div className="container">
              <div className="h4 font-narrow inner-course-bar">
                <div className="mb-0" id="price-section">
                  <Col l={6} m={12} s={12} className="center-s"></Col>
                  <Col l={6} m={12} s={12} className="enroll-section">
                    {!data.enrolled && (
                      <div>
                        <BuyCourseButton
                          data={data}
                          onEnroll={onEnroll}
                          onRedeem={onRedeem}
                          errorMessage={errorMessage}
                          requiredCourse={data.required_course}
                        />
                      </div>
                    )}
                    {data.completed && (
                      <Row>
                        <Col
                          l={12}
                          m={12}
                          s={12}
                          className="valign-wrapper right"
                          id="floating-buttons"
                        >
                          <div>
                            <a
                              className="btn"
                              id="give-rating-button"
                              onClick={() =>
                                $("#course_rating_button").trigger("click")
                              }
                            >
                              {data.has_reviewed ? (
                                <span>
                                  <span className="hide-on-small-only">
                                    Lihat
                                  </span>{" "}
                                  Rating Anda
                                </span>
                              ) : (
                                <span>
                                  <span className="hide-on-small-only">
                                    Beri
                                  </span>{" "}
                                  Rating
                                </span>
                              )}
                            </a>
                          </div>
                          {/* {data.has_reviewed && data.user_rating && (
                            <div id="user-course-rating-div">
                              <span
                                id="user-course-rating-head"
                                className="font-medium"
                              >
                                Rating Darimu
                              </span>
                              <br />
                              <StarRatings
                                rating={data.user_rating}
                                starDimension={"1.25rem"}
                                starRatedColor={"#f2c94c"}
                                starSpacing={"1px"}
                              />
                            </div>
                          )} */}
                          <div>
                            <Link
                              to={`/course/${data.slug}/certificate`}
                              className="btn modal-close"
                              id="floating-recap-button"
                            >
                              <span className="hide-on-small-only">Lihat</span>{" "}
                              Sertifikat
                            </Link>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </Col>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FloatingCourseBar;



// WEBPACK FOOTER //
// ./src/components/Course/components/FloatingCourseBar.js